import BaseApi from '../base/base'
import Attachment from '../../models/attachment'
import AttachmentForm from '../../forms/attachment'

export default class AttachmentApi extends BaseApi {
  constructor() {
    super()
    this.path = '/attachments'
  }

  async create(params: AttachmentForm) {
    const response = await this.postRequest(params)
    return new Attachment(response.data)
  }
}
